<script lang="ts">
    import RewardsPopUpWidgetLauncherManager from "@apps/rewards/widgets/rewards_popup_widget/utils/RewardsPopUpWidgetLauncherManager/RewardsPopUpWidgetLauncherManager";
    import type NudgesEntity from "@modules/nudges/entities/NudgesEntity";

    import BaseButton from "@components/Buttons/BaseButton.svelte";

    import { nudgesCustomerRewardsState } from "../state/nudgesCustomerRewardsState";

    export let nudges: NudgesEntity;
    export let rewardsPopUpWidgetLauncherManager: RewardsPopUpWidgetLauncherManager;

    const { NudgesPopUpWidgetVisibilityManager, nudgesService } =
        nudgesCustomerRewardsState();

    const handleAddView = () => {
        nudgesService.addAction({
            nudgeId: nudges.nudge.id,
        });
        nudgesService.addViewed({
            nudgeId: nudges.nudge.id,
        });
        NudgesPopUpWidgetVisibilityManager.nudgesPopUpWidgetHide();

        rewardsPopUpWidgetLauncherManager.rewardsPopUpWidgetShow();
    };
</script>

<BaseButton
    class="gw-nudges-modal__active-button"
    on:click={() => handleAddView()}>{nudges.template.ctaw.text}</BaseButton
>
